<script setup>

</script>

<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8 14L13.4209 11.1944C13.6313 11.0855 13.7365 11.0311 13.8132 10.9509C13.8811 10.88 13.9327 10.7949 13.9643 10.7017C14 10.5963 14 10.4778 14 10.2407C14 9.10127 14 6.71226 14 5.02182M8 14L2.57906 11.1944C2.36872 11.0855 2.26355 11.0311 2.18677 10.9509C2.11887 10.88 2.0673 10.7949 2.03572 10.7017C2 10.5963 2 10.4773 2 10.2391V5.02182M8 14C8 14 8 10.3177 8 7.95826M14 5.02182C11.6569 6.16857 10.3431 6.81151 8 7.95826M14 5.02182C12.8284 4.41547 12.1716 4.07552 11 3.46917M2 5.02182L7.5124 2.16888C7.69098 2.07645 7.78027 2.03024 7.87416 2.01207C7.95729 1.99598 8.04271 1.99598 8.12585 2.01207C8.21973 2.03024 8.3088 2.07634 8.48696 2.16855C9.1108 2.49142 10.2062 3.05833 11 3.46917M2 5.02182C2 5.02182 3.82843 5.91666 5 6.49004M8 7.95826C6.82843 7.38489 6.17157 7.06342 5 6.49004M5 6.49004C7.34315 5.31032 8.65685 4.64889 11 3.46917M5 6.49004C5 7.06342 5 7.38489 5 7.95826"
      stroke="#105E84" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<style scoped>

</style>
